import { Form, Formik, Field as FormikField } from 'formik'
import React from 'react'
import { SelectField, SimpleField } from '../../../formik/Fields'
import { getCountryCurrencies } from '../../../utils/coutriesUtils'
import Button from '../../../_library/Button'
import Modal from 'react-modal'

import _find from 'lodash/find'
import modalStyle from '../../../../_common/core/modalStyle'

const currencies = getCountryCurrencies()

const AdditionalCurrencyModal = props => {
  const { values, isOpen, handleCancel, handleSubmit, additionalCurrencies, selected } = props
  const isEditing = Boolean(selected)

  const filteredCurrencies = currencies.filter(
    item =>
      (item.value !== values?.currency?.currency &&
        !_find(additionalCurrencies, currencyItem => currencyItem?.currency?.currency === item.value)) ||
      item.value === selected?.currency,
  )

  return (
    <Modal
      className="modal-dialog modal-trans"
      style={modalStyle}
      isOpen={isOpen}
      contentLabel="Modal"
      onRequestClose={handleCancel}
      closeTimeoutMS={150}
      ariaHideApp={false}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <div>{isEditing ? 'Edit Additional Currency' : 'Add Additional Currency'}</div>
          </div>
          <div className="modal-body">
            <Formik
              enableReinitialize={false}
              initialValues={
                selected
                  ? {
                    ...selected,
                    additionalCurrency: selected.currency,
                  }
                  : {
                    additionalCurrency: '',
                    payment_method: '',
                    tax_class_id: '',
                    external_payment_provider: '',
                  }
              }
              onSubmit={handleSubmit}
              validate={data => {
                const errors = {}

                if (!(data.additionalCurrency && data.additionalCurrency.length)) {
                  errors.additionalCurrency = 'Required'
                }

                if (!data.payment_method) {
                  errors.payment_method = 'Required'
                }

                return errors
              }}
              render={formikProps => (
                <Form autoComplete="off">
                  <div className="row">
                    <div className="col-xs-6">
                      <FormikField
                        name="additionalCurrency"
                        label="Select Currency"
                        component={SelectField}
                        defaultOption={{ value: '', label: 'Select Currency...' }}
                        options={filteredCurrencies}
                        disabled={isEditing}
                      />
                    </div>
                    <div className="col-xs-6">
                      <FormikField
                        name="payment_method"
                        label="Payment Method"
                        type="text"
                        component={SimpleField}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-6">
                      <FormikField
                        name="tax_class_id"
                        label="Tax Class ID (optional)"
                        type="text"
                        component={SimpleField}
                      />
                    </div>
                    <div className="col-xs-6">
                      <FormikField
                        name="external_payment_provider"
                        label="External Payment Provider (optional)"
                        type="text"
                        component={SimpleField}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="modal-footer footer-in-form right">
                      <div className="btn-toolbar btn-toolbar-right">
                        <Button
                          className="btn btn-success btn-shadow"
                          type="button"
                          onClick={() => {
                            formikProps.handleSubmit()
                          }}
                          loading={formikProps.isSubmitting}
                        >
                          {isEditing ? 'Save' : 'Add'}
                        </Button>
                        <Button className="btn btn-cancel btn-shadow" type="button" onClick={handleCancel}>
                          Cancel
                        </Button>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default AdditionalCurrencyModal
